import { navigate, RouteComponentProps } from '@reach/router';
import React, { Component } from 'react';

import { Consumer, IActions } from '../../store';

export interface IAnimatedRoute extends RouteComponentProps {
  component: any;
  className?: string;
  actions?: IActions;
  scope?: 'user' | 'guest' | 'staff';
  auth?: { token: string };
}

export class Route extends Component<IAnimatedRoute> {
  public componentDidMount(): void {
    const { auth, scope: sc, location } = this.props;
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });

    if (!auth) {
      return;
    }

    // deprecating scope prop
    // convention: ALL staff routes will start with /staff
    // TODO: player routes have to start with /player
    const scope = sc || (location ? (location as any).pathname.split('/')[1] : '');

    // execute just after lifecycle run
    if (
      auth.token &&
      scope === 'guest' &&
      !(location as any).pathname.startsWith('/staff/club/create')
    ) {
      setTimeout(navigate.bind(this, '/home'));
    } else if (
      auth.token &&
      scope === 'staff' &&
      (location as any).pathname.match(/^\/staff(\/|\/login)?$/i)
    ) {
      setTimeout(navigate.bind(this, '/staff/home'));
    } else if (
      !auth.token &&
      scope === 'staff' &&
      !(location as any).pathname.match(/^\/staff\/club\/create/i) &&
      !(location as any).pathname.match(/^\/staff\/login/i) &&
      !(location as any).pathname.match(/^\/staff\/requestResetPassword/i)
    ) {
      setTimeout(navigate.bind(this, '/staff'));
    } else if (!auth.token && scope === 'user') {
      setTimeout(navigate.bind(this, '/login'));
    }
  }

  public render(): JSX.Element {
    const { component, className, ...props } = this.props;

    const ShadowRoute = component;
    const scope =
      props.scope || (props.location ? (props.location as any).pathname.split('/')[1] : '');

    return (
      <div className={`route ${className || ''} ${scope || ''}-scope`}>
        <ShadowRoute {...props} />
      </div>
    );
  }
}

const AnimatedRoute = (props: any) => (
  <Consumer>
    {({ auth }) => (
      <div>
        <Route auth={auth} {...props} />
      </div>
    )}
  </Consumer>
);

export { AnimatedRoute };
